/**
 * Dashboard configuration for role-based tab and component management
 * Defines which tabs and features are available for each role
 */

export const DASHBOARD_CONFIG = {
  manager: {
    tabs: [
      { id: 'overview', label: 'Overview', path: '', icon: 'overview', domainColor: null },
      { id: 'vehicles', label: 'Vehicles', path: 'vehicles', icon: 'vehicles', domainColor: '#0d9488' },
      { id: 'customers', label: 'Customers', path: 'customers', icon: 'customers', domainColor: '#6366f1' },
      { id: 'transactions', label: 'Transactions', path: 'transactions', icon: 'transactions', domainColor: '#3b82f6' },
      { id: 'payments', label: 'Payments', path: 'payments', icon: 'payments', domainColor: '#f59e0b' },
      { id: 'rto', label: 'Long Term Lease', path: 'rto', icon: 'rto', domainColor: '#3b82f6' },
      { id: 'tasks', label: 'Tasks', path: 'tasks', icon: 'tasks', domainColor: '#10b981' },
      { id: 'work-calendar', label: 'Calendar', path: 'work-calendar', icon: 'calendar', domainColor: '#f97316' },
      { id: 'reports', label: 'Reports', path: 'reports', icon: 'report', domainColor: null },
      { id: 'settings', label: 'Settings', path: 'settings', icon: 'settings', domainColor: null },
    ],
    defaultTab: 'overview',
  },
  auditor: {
    tabs: [
      { id: 'overview', label: 'Overview', path: '', icon: 'overview', domainColor: null },
      { id: 'vehicles', label: 'Vehicles', path: 'vehicles', icon: 'vehicles', domainColor: '#0d9488' },
      { id: 'customers', label: 'Customers', path: 'customers', icon: 'customers', domainColor: '#6366f1' },
      { id: 'transactions', label: 'Transactions', path: 'transactions', icon: 'transactions', domainColor: '#3b82f6' },
      { id: 'payments', label: 'Payments', path: 'payments', icon: 'payments', domainColor: '#f59e0b' },
      { id: 'rto', label: 'Long Term Lease', path: 'rto', icon: 'rto', domainColor: '#3b82f6' },
      { id: 'tasks', label: 'Tasks', path: 'tasks', icon: 'tasks', domainColor: '#10b981' },
      { id: 'work-calendar', label: 'Calendar', path: 'work-calendar', icon: 'calendar', domainColor: '#f97316' },
      { id: 'reports', label: 'Reports', path: 'reports', icon: 'report', domainColor: null },
      { id: 'settings', label: 'Settings', path: 'settings', icon: 'settings', domainColor: null },
    ],
    defaultTab: 'overview',
  },
  admin: {
    tabs: [
      { id: 'overview', label: 'Overview', path: '', icon: 'overview', domainColor: null },
      { id: 'vehicles', label: 'Vehicles', path: 'vehicles', icon: 'vehicles', domainColor: '#0d9488' },
      { id: 'customers', label: 'Customers', path: 'customers', icon: 'customers', domainColor: '#6366f1' },
      { id: 'transactions', label: 'Transactions', path: 'transactions', icon: 'transactions', domainColor: '#3b82f6' },
      { id: 'payments', label: 'Payments', path: 'payments', icon: 'payments', domainColor: '#f59e0b' },
      { id: 'rto', label: 'Long Term Lease', path: 'rto', icon: 'rto', domainColor: '#3b82f6' },
      { id: 'tasks', label: 'Tasks', path: 'tasks', icon: 'tasks', domainColor: '#10b981' },
      { id: 'work-calendar', label: 'Calendar', path: 'work-calendar', icon: 'calendar', domainColor: '#f97316' },
      { id: 'reports', label: 'Reports', path: 'reports', icon: 'report', domainColor: null },
      { id: 'settings', label: 'Settings', path: 'settings', icon: 'settings', domainColor: null },
    ],
    defaultTab: 'overview',
  },
};

/**
 * Get configuration for a specific role
 * @param {string} role - User role (manager, admin, customer)
 * @returns {object} Configuration object with tabs and settings
 */
export function getDashboardConfig(role) {
  return DASHBOARD_CONFIG[role] || DASHBOARD_CONFIG.manager;
}

/**
 * Get available tabs for a role
 * @param {string} role - User role
 * @returns {array} Array of tab objects
 */
export function getTabsForRole(role) {
  const config = getDashboardConfig(role);
  return config.tabs;
}

/**
 * Check if a role has access to a specific tab
 * @param {string} role - User role
 * @param {string} tabId - Tab identifier
 * @returns {boolean} True if role has access to tab
 */
export function hasAccessToTab(role, tabId) {
  const tabs = getTabsForRole(role);
  return tabs.some(tab => tab.id === tabId);
}

/**
 * Get the default tab for a role
 * @param {string} role - User role
 * @returns {string} Default tab identifier
 */
export function getDefaultTab(role) {
  const config = getDashboardConfig(role);
  return config.defaultTab;
}
